const labels = { normal: 'Normal', holo: 'Holo', reverse: 'Reverse Holo', firstEdition: '1st Edition', wPromo: 'W Promo', preRelease: 'Prerelease', jumbo: 'Jumbo', metal: 'Metal', lenticular: 'Lenticular' };
const names = { 'trick-or-trade': 'Trick or Trade (Halloween)', gamestop: 'GameStop', 'eb-games': 'EB Games', 'pokemon-center': 'Pokémon Center', 'pre-release': 'Prerelease', 'set-logo': 'Set logo', staff: 'Staff', '1st-edition': '1st Edition', 'w-promo': 'W Promo', 'player-rewards-program': 'Prize Pack', snowflake: 'Holiday snowflake', pokeball: 'Poké Ball', masterball: 'Master Ball' };
export const baseVariant = key => String(key || '').split('~')[0];
export const printingStamps = key => String(key || '').split('~').find(part => part.startsWith('stamp='))?.slice(6).split('+') || [];
export const stampLabel = value => names[value] || value.replace(/-/g, ' ').replace(/\b\w/g, char => char.toUpperCase());
export function printingLabel(key) {
  const [base, ...parts] = String(key || '').split('~');
  const cosmos = base === 'normal' && parts.includes('foil=cosmos');
  const text = [cosmos ? 'Cosmos Holo' : labels[base] || base];
  for (const part of parts) {
    if (cosmos && part === 'foil=cosmos') continue;
    const [field, value = ''] = part.split('=');
    if (field === 'detail') text.push('Special printing');
    else for (const token of value.split('+')) {
      const name = names[token] || token.replace(/-/g, ' ').replace(/\b\w/g, char => char.toUpperCase());
      text.push(field === 'foil' ? `${name} foil` : name);
    }
  }
  return text.join(' · ');
}
